import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Alert, Modal, notification } from 'antd';
import roleService from 'services/role.services';
import CustomTransfer from 'components/form-elements/CustomTransfer';

const AddForm = ({
  visible,
  error,
  submitting,
  selectedRole,
  handleSubmitForm,
  handleCloseForm,
}) => {
  const [form] = Form.useForm();
  const [authorities, setAuthorities] = useState([]);

  useEffect(() => {
    getAuthorities();
  }, []);

  const getAuthorities = async () => {
    try {
      const { payload } = await roleService.getAuthorities();
      setAuthorities(payload);
    } catch (authError) {
      notification.error({
        message: 'İşlem Başarısız',
        description: authError.message || 'Bir hata oluştu.',
      });
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      handleSubmitForm(values);
    } catch (err) {
      console.error('Validation Failed:', err);
    }
  };

  return (
    <Modal
      width={768}
      open={visible}
      footer={false}
      title="Rol İşlemleri"
      onCancel={handleCloseForm}
      destroyOnClose
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={{
          name: selectedRole?.name || '',
          authorityIds: selectedRole?.authorities?.map((item) => item.identifier) || [],
        }}
      >
        <Form.Item
          name="name"
          label="İzin Adı"
          rules={[{ required: true, message: 'Zorunlu Alan' }]}
        >
          <Input className="input__default" placeholder="İzin Adı" />
        </Form.Item>
        <Form.Item
          name="authorityIds"
          label="İzinler"
          rules={[{ required: true, message: 'Zorunlu Alan' }]}
        >
          <CustomTransfer dataSource={authorities} />
        </Form.Item>
        {error && (
          <Form.Item>
            <Alert message={error} type="error" showIcon />
          </Form.Item>
        )}
        <Form.Item className="text-align-right">
          <Button
            className="button button__outline mr-3"
            type="ghost"
            htmlType="button"
            disabled={submitting}
            onClick={handleCloseForm}
          >
            Vazgeç
          </Button>
          <Button
            className="button button__fill"
            type="primary"
            htmlType="submit"
            disabled={submitting}
            loading={submitting}
          >
            Kaydet
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  selectedRole: PropTypes.shape({
    name: PropTypes.string,
    authorities: PropTypes.arrayOf(
      PropTypes.shape({
        identifier: PropTypes.string.isRequired,
      }),
    ),
  }),
  handleSubmitForm: PropTypes.func.isRequired,
  handleCloseForm: PropTypes.func.isRequired,
};

AddForm.defaultProps = {
  error: null,
  selectedRole: {},
};

export default AddForm;
